import {setQueryParam, deleteQueryParam} from 'src/utils/url';

class FilterToolbar {
  constructor() {
    this.searchOpened = this.searchOpened.bind(this);
    this.toggleSortDropDown = this.toggleSortDropDown.bind(this);
    this.sortChanged = this.sortChanged.bind(this);
    this.ordQtyChanged = this.ordQtyChanged.bind(this);
    this.individualShipEligibleChanged = this.individualShipEligibleChanged.bind(
      this
    );
    this.internationalShipEligibleChanged = this.internationalShipEligibleChanged.bind(
      this
    );
    this.specialtyChanged = this.specialtyChanged.bind(this);
    this.halftonesChanged = this.halftonesChanged.bind(this);
    this.toggleFiltersSection = this.toggleFiltersSection.bind(this);
    this.mobileFiltersHide = this.mobileFiltersHide.bind(this);
    this.filterChanged = this.filterChanged.bind(this);
    this.isfilterSortShown = true;
    this.initBehavior();
  }

  initBehavior() {
    $(document).bind('pcToolbar.searchOpened', this.searchOpened);
    $(document).bind('pcToolbar.searchClosed', this.searchClosed);
    $(document).on(
      'click',
      '.pc-Styles .pc-ToolBar-sortForm',
      this.toggleSortDropDown
    );
    $(document).on(
      'click',
      '.pc-ToolBar-sort .pc-OverlayDropdown-link',
      this.sortChanged
    );
    $(document).on(
      'change',
      '.pc-Styles .pc-ToolBar-toggle-min-qty',
      this.ordQtyChanged
    );
    $(document).on(
      'change',
      '.pc-Styles .pc-ToolBar-toggle-individual-ship-eligible',
      this.individualShipEligibleChanged
    );
    $(document).on(
      'change',
      '.pc-Styles .pc-ToolBar-toggle-international-ship-eligible',
      this.internationalShipEligibleChanged
    );
    $(document).on(
      'change',
      '.pc-Styles .pc-ToolBar-toggle-specialty',
      this.specialtyChanged
    );
    $(document).on(
      'change',
      '.pc-Styles .pc-ToolBar-toggle-halftones',
      this.halftonesChanged
    );
    $(document).on(
      'click',
      '.pc-Styles .pc-ToolBar-filterNav-area',
      this.toggleFiltersSection
    );
    $(document).on(
      'click',
      '.pc-Filters-headerClose, .pc-Filters-footer',
      this.mobileFiltersHide
    );
    return $(document).on(
      'click',
      '.pc-FiltersGroup .pc-FiltersGroup-toggle',
      this.toggleFilterList
    );
  }

  toggleFilterList() {
    const $el = $(this);
    const $filterGroup = $el.parent();
    CustomInk.Metrics.fireEvent(
      'catalog filter',
      $filterGroup.siblings('.pc-FiltersGroup-header').text(),
      $el.text()
    );
    const $toggleSection = $filterGroup.children(
      '.pc-FiltersGroup-values-toggleSection'
    );
    if ($el.text() === 'Show more') {
      $el.text('Show fewer');
    } else {
      $el.text('Show more');
    }
    return $toggleSection.slideToggle();
  }

  dropdown() {
    return $('.pc-ToolBar-sort .pc-OverlayDropdown');
  }

  filtersEl() {
    return $('.pc-Filters');
  }

  searchOpened(e) {
    return $('.pc-ToolBar-filterNav, .pc-ToolBar-sort').hide();
  }

  searchClosed(e) {
    return $('.pc-ToolBar-filterNav, .pc-ToolBar-sort').fadeIn(50);
  }

  toggleSortDropDown(e) {
    e.stopPropagation();
    return ProductCatalog.OverlayDropdown.open(e, this.dropdown());
  }

  sortChanged(e) {
    const sortByUrl = new URL(e.target.href);
    const sortByValue = sortByUrl.searchParams.get('sort_by');
    if (sortByValue != null) {
      CustomInk.Metrics.fireEvent('product sort', sortByValue);
    }
    return true;
  }

  ordQtyChanged(e) {
    const query = 'min_qty[]';
    let value = null;
    let eventTagValue = 'off';
    let url = deleteQueryParam(query);
    url = deleteQueryParam('page', url);
    const toggleCheckbox = $(e.target);
    if (toggleCheckbox.is(':checked')) {
      value = 1;
      eventTagValue = 'on';
    }
    if (value !== null) {
      url = setQueryParam(query, value, url);
    }
    CustomInk.Metrics.fireEvent(
      'product quantity',
      'order fewer than six',
      eventTagValue
    );

    ProductCatalog.Listing.updateStyles(url);
  }

  individualShipEligibleChanged(e) {
    const query = 'individual_ship_eligible[]';
    let value = null;
    let eventTagValue = 'off';
    let url = deleteQueryParam(query);
    url = deleteQueryParam('page', url);
    const toggleCheckbox = $(e.target);
    if (toggleCheckbox.is(':checked')) {
      value = true;
      eventTagValue = 'on';
    }
    if (value !== null) {
      url = setQueryParam(query, value, url);
    }
    CustomInk.Metrics.fireEvent(
      'product individual ship eligible',
      'ordering items for individual shipping',
      eventTagValue
    );

    ProductCatalog.Listing.updateStyles(url);
  }

  internationalShipEligibleChanged(e) {
    const query = 'international_ship_eligible[]';
    let value = null;
    let eventTagValue = 'off';
    let url = deleteQueryParam(query);
    url = deleteQueryParam('page', url);
    const toggleCheckbox = $(e.target);
    if (toggleCheckbox.is(':checked')) {
      value = true;
      eventTagValue = 'on';
    }
    if (value !== null) {
      url = setQueryParam(query, value, url);
    }
    CustomInk.Metrics.fireEvent(
      'product international ship eligible',
      'ordering items for international shipping',
      eventTagValue
    );

    ProductCatalog.Listing.updateStyles(url);
  }

  specialtyChanged(e) {
    const query = 'specialty[]';
    let value = null;
    let eventTagValue = 'off';
    let url = deleteQueryParam(query);
    url = deleteQueryParam('page', url);
    const toggleCheckbox = $(e.target);
    if (toggleCheckbox.val() !== 'both') {
      value = toggleCheckbox.val();
      eventTagValue = 'on';
    }
    if (value !== null) {
      url = setQueryParam(query, value, url);
    }
    CustomInk.Metrics.fireEvent('product specialty', eventTagValue);

    ProductCatalog.Listing.updateStyles(url);
  }

  halftonesChanged(e) {
    const query = 'halftones[]';
    let value = null;
    let eventTagValue = 'off';
    let url = deleteQueryParam(query);
    url = deleteQueryParam('page', url);
    const toggleCheckbox = $(e.target);
    value = toggleCheckbox[0].checked
    if (value) {
      url = setQueryParam(query, value, url);
      eventTagValue = 'on';
    } else {
      eventTagValue = 'off';
      url = deleteQueryParam('page', url);
    }
    CustomInk.Metrics.fireEvent('product halftones', eventTagValue);

    ProductCatalog.Listing.updateStyles(url);
  }

  toggleFiltersSection() {
    if ($(window).width() < 700) {
      this.mobileFiltersShow();
    } else {
      const filterNavToggle = $('.pc-ToolBar-filterNav')
      const filtersSection = $('.pc-Styles-filters');
      const productsSection = $('.pc-Styles-products');
      if (productsSection.hasClass('is-filterSortShown')) {
        filterNavToggle.removeClass('activeNav');
        filtersSection.hide();
        this.fireFiltersToggleEvent();
      } else {
        filterNavToggle.addClass('activeNav');
        filtersSection.show();
        this.fireFiltersToggleEvent();
      }
      this.isfilterSortShown = !this.isfilterSortShown;
      productsSection.toggleClass('is-filterSortShown');
      ProductCatalog.Toolbar.waypointRefreshFooter();
      $(document).trigger('filterToolbar.toggleFiltersSection');
    }
    return undefined;
  }

  fireFiltersToggleEvent() {
    let value = 'hide all';
    if (this.filtersEl().is(':visible')) {
      value = 'show all';
    }
    return CustomInk.Metrics.fireEvent('catalog filter', value);
  }

  mobileFiltersShow() {
    return requestAnimationFrame(() => {
      this.filtersEl().show();
      return this.fireFiltersToggleEvent();
    });
  }

  mobileFiltersHide(e) {
    requestAnimationFrame(() => {
      return this.filtersEl().hide(() => {
        return this.fireFiltersToggleEvent();
      });
    });
    return this.filtersEl().removeAttr('style');
  }

  filterChanged() {
    requestAnimationFrame(() => {
      if (!($(window).width() < 700)) {
        return;
      }
      return this.filtersEl().hide().removeAttr('style');
    });
    return undefined;
  }
}

jQuery(() => (ProductCatalog.FilterToolbar = new FilterToolbar()));
